import { localGetJson, localSetJson } from './local_storage_lib';

interface RecentDevice {
   wikiid: number;
   variantid?: number;
   device: string;
   title: string;
   image_url: string;
}

const MAX_RECENT_DEVICES = 10;

export function addRecentDevice({ wikiid, variantid, device, title, image_url }: RecentDevice) {
   const currentRecentDevices = localGetJson('recentDevices') ?? [];
   const newRecentDevices = [
      { wikiid, variantid, device, title, image_url },
      ...currentRecentDevices.filter((device: RecentDevice) => device.wikiid !== wikiid),
   ];
   localSetJson('recentDevices', newRecentDevices.slice(0, MAX_RECENT_DEVICES));
}
